import {useEffect, useState} from "react";
import {Button, Checkbox, FormControlLabel, Grid, TextField} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {cartActions} from "../../store/cart/slice";
import Typography from "@mui/material/Typography";

const ProductShippingForm = ({ product, camperKey, programSessionId, camperName }) => {
    const [formState, setFormState] = useState({
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
    });
    const products = useSelector(state => state.cart.products);
    const dispatch = useDispatch();
    const [showShippingForm, setShowShippingForm] = useState(false);

    useEffect(() => {
        if (products.filter(p => (p.id === product.id && p.camperKey === camperKey)).length > 0){
            setShowShippingForm(true);
            let shipping = products.find(p => (p.id === product.id && p.camperKey === camperKey)).shipping;
            if (shipping) setFormState(shipping);
        }
    }, []);

    useEffect(() => {
        //update the shipping address for this form's product each time the form state changes.
        //this keeps us from needing a save/submit button for each shipping form
        dispatch(cartActions.updateProductShipping({product, camperKey, formState}));
    }, [formState]);

    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const toggleProduct = (event) => {
        let newProduct = {...product, camperKey, programSessionId};
        console.log(newProduct);
        if (event.target.checked){
            dispatch(cartActions.addProduct(newProduct));
            setShowShippingForm(true);
        }
        else{
            dispatch(cartActions.removeProduct(newProduct));
            setShowShippingForm(false);
        }
    }

    return (
        <>
            <FormControlLabel
                control={<Checkbox checked={products.filter(p => (p.id === product.id && p.camperKey === camperKey)).length > 0} onChange={toggleProduct}/>}
                label={<Typography sx={{fontSize: "16pt", color: "gray"}}>{`${product.name} for ${camperName} - $${product.price}`}</Typography>}
            />
            {showShippingForm &&
            <>
                <Typography sx={{fontWeight: "bold", marginTop: "3px", marginBottom: "3px"}}>Shipping address</Typography>
                <Grid container direction="row" spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            id="firstName"
                            name="firstName"
                            label="First Name"
                            value={formState.firstName}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="lastName"
                            name="lastName"
                            label="Last Name"
                            value={formState.lastName}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="address1"
                            name="address1"
                            label="Address"
                            value={formState.address1}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="address2"
                            name="address2"
                            label="Apt, Suite, etc. (optional)"
                            value={formState.address2}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            id="city"
                            name="city"
                            label="City"
                            value={formState.city}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            id="state"
                            name="state"
                            label="State"
                            value={formState.state}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            id="zip"
                            name="zip"
                            label="Zip"
                            value={formState.zip}
                            onChange={handleChange}
                            style={{width: "100%"}}
                        />
                    </Grid>
                </Grid>
            </>}
        </>
    );
}

export default ProductShippingForm;
